"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValidationErrors_1 = require("../../../../enums/Validation/ValidationErrors");
const Resource_1 = __importDefault(require("../../../Resource"));
const CustomAsync_1 = __importDefault(require("../../../decorators/CustomAsync"));
const Di_1 = __importDefault(require("../../../injectables/Di"));
const EProductDocumentType_1 = require("../../../../enums/ProductSheet/DocumentsTemplates/EProductDocumentType");
const ETypePersonneJuridique_1 = require("../../../../enums/ClientSheet/ETypePersonneJuridique");
class ProductSheetAddTemplateToFileRequestResource extends Resource_1.default {
}
exports.default = ProductSheetAddTemplateToFileRequestResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(EProductDocumentType_1.EProductDocumentType),
    __metadata("design:type", String)
], ProductSheetAddTemplateToFileRequestResource.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(ETypePersonneJuridique_1.ETypePersonneJuridique),
    __metadata("design:type", String)
], ProductSheetAddTemplateToFileRequestResource.prototype, "typePersonneJuridique", void 0);
__decorate([
    (0, CustomAsync_1.default)((id) => Di_1.default.getFileService().exists(id), {
        message: ValidationErrors_1.EValidationError.fileNotExists,
    }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetAddTemplateToFileRequestResource.prototype, "fileId", void 0);
